module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_LeftArrow_16"],"polygon":[{"$":{"points":"14 6 8 6 8 3 2 8 8 13 8 10 14 10 14 6","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_LeftArrow_16.svg
// module id = biZF
// module chunks = 1